import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import { getRating } from '@/helpers/statusIncident.js';
import TicketItem from '@/components/request/elements/TicketItem/TicketItem.vue';
import TicketCommentsRich from '@/components/request/elements/TicketCommentsRich';
import { getIncidentStatus } from '@/helpers/statusIncident.js';
import { showError } from '@/helpers/globalHelpers';
import RatingDialog from '@/components/request/elements/RatingDialog/RatingDialog.vue';
import ReassignUserDialog from '../../request/elements/ReassignUserDialog';
import UserConfirmDialog from '@/components/request/elements/AssignUserConfirmDialog/AssignUserConfirmDialog.vue';
import AddUserTicketDialog from '@/components/request/elements/AddUserTicketDialog/AddUserTicketDialog.vue';
import TicketDetailElement from '@/components/request/elements/TicketDetailElement/TicketDetailElement.vue';
import UserAdditionalDialog from '@/components/request/elements/UserAdditionalDialog/UserAdditionalDialog.vue';
import ReassignedUserHistoryDialog from '@/components/request/elements/ReassignedUserHistoryDialog/ReassignedUserHistoryDialog.vue';
import TicketAttentionDialog from '@/components/request/elements/TicketAttentionDialog/TicketAttentionDialog.vue';
import TicketReclassifyDialog from '@/components/request/elements/TicketReclassifyDialog/TicketReclassifyDialog.vue';
import TicketChangeCompanyDialog from '@/components/request/elements/TicketChangeCompanyDialog/TicketChangeCompanyDialog.vue';
import HtmlViewer from '@/components/global/HtmlViewer';


export default {
	name: 'TicketDetail',
	data() {
		return {
			reclassifyDialog: false,
			changeCompanyDialog: false,
			loadingInitTicket: false,
			signedEvidences: {},
			loadingEvidences: {},
			reassignUserDialog: false,
			userConfirmDialog: false,
			addUserDialog: false,
			additionalUsersDialog: false,
			reassignedUserHistoryDialog: false,
			showDialog: false,
			source: 'request-detail',
			breadcrumbs: [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'Dashboard',
					},
				},
				{
					text: 'Incidentes',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'IncidentsHome',
					},
				},
				{
					text: 'Solicitudes de Tickets',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'RequestList',
					},
				},
				{
					text: 'Detalle de Ticket',
					link: true,
					exact: true,
					disabled: true,
				},
			],
			statusList: [
				{ text: 'Solicitado', value: 'Solicitado' },
				{ text: 'Asignado', value: 'Asignado' },
				{ text: 'Resolución', value: 'Resolución' },
				{ text: 'Consulta', value: 'Consulta' },
				{ text: 'Cerrado', value: 'Cerrado' },
			],
			loading: false,
			filters: {
				q: null,
				page: 1,
				area: null,
				status: null,
				pagination: true,
				per_page: process.env.VUE_APP_PAGINATION_PER_PAGE || 10,
			},
			// mode: 'REQUEST', // TICKETSTARTED,REQUEST
			isRatingActive: false,
		};
	},



	created() {
		this.getRequestId();
		this.getResponsibles();
	},

	mounted() {
	},

	computed: {

		...mapState('ticket', ['ticket']),
		...mapState('auth', ['user', 'activities']),
		hasStartTicketPermission() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'detalleSolicitud',
				'iniciarTicket'
			);
		},
		hasCommentPermission() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'detalleSolicitud',
				'escribirComentarios'
			);
		},
		showSendComments() {
			if (this.ticket?.ticket_attention?.responsible_id?.id !== this.user?.id) {
				return false;
			} else {
				return true;
			}
		},

		isColumns() {
			return (
				this.ticket?.ticket_attention &&
				!['SOLICITADO', 'CANCELADO'].includes(this.ticket?.status)
			);
		},

		canShowTicketDetail() {
			if (!this.ticket || !this.user) return false;

			const isSuperAdmin = this.activities?.some(
				(activity) =>
					(activity.module_name === 'solicitudes' &&
						activity.page_name === 'detalleSolicitud' &&
						activity.activity_name === 'MostrarSolicitudSuperAdmin') ||
					activity.activity_name === 'mostrarSolicitud'
			);

			const hasPermission = this.validateUserPermission(this.ticket, this.user.id);
			const isResponsible = this.ticket?.responsible_id?.id === this.user?.id;

			return isSuperAdmin || hasPermission || isResponsible;
		},

		hasDisabledTicketReassign() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'listaSolicitudes',
				'reasignarResponsable'
			);
		},

		ticketUserConfirm() {
			if (this.ticket) {
				const [userconfirm] = this.ticket?.ticket_user_confirm;
				return userconfirm;
			}
		},

		isTicketReclassifiable() {
			const allowedStatuses = [
				'SOLICITADO',
				'EN ATENCION',
				'CONSULTA',
				'CONSULTA ADICIONAL',
				'CONSULTA EXTERNA',
				'RESOLUCION',
			];
			return this.ticket && allowedStatuses.includes(this.ticket.status);
		}
	},

	methods: {
		getIncidentStatus,
		...mapActions('user', ['getResponsibles']),
		...mapActions('ticket', ['getTicketById', 'cleanTicket']),
		...mapActions('ticketAttention', ['createTicketAttention']),

		...mapActions('assetAssignment', ['signedFileURl']),

		async getEvidenceSigned(evidenceId, evidenceFile) {
			if (this.signedEvidences[evidenceId]) {
				return this.signedEvidences[evidenceId];
			}

			this.$set(this.loadingEvidences, evidenceId, true);

			const { error, response, ok } = await this.signedFileURl({
				data: { fileUrl: evidenceFile },
			});

			if (ok) {
				this.$set(this.signedEvidences, evidenceId, response.signedUrl);
				this.$set(this.loadingEvidences, evidenceId, false);
				return response.signedUrl;
			} else {
				showError(error);
				this.$set(this.loadingEvidences, evidenceId, false);
				return null;
			}
		},

		async openPreviewDialog(evidenceId, evidenceFile) {
			this.$set(this.loadingEvidences, evidenceId, true);
			
			const signedUrl = await this.getEvidenceSigned(evidenceId, evidenceFile);
			const fileUrl = signedUrl || evidenceFile;
			const fileType = this.getFileExtension(evidenceFile);
			const fileName = this.getFileName(evidenceFile);
			
			// Para imágenes, abrir en nueva pestaña con visor HTML
			if (this.isImageFile(fileType)) {
				this.openImageInNewTab(fileUrl, fileName);
				this.$set(this.loadingEvidences, evidenceId, false);
				return;
			}

			// Para PDFs, abrir en nueva pestaña con visor HTML (evita la descarga forzada)
			if (this.isPdfFile(fileType)) {
				this.openPdfInNewTab(fileUrl, fileName);
				this.$set(this.loadingEvidences, evidenceId, false);
				return;
			}

			// Determinar la URL de preview según el tipo de archivo
			let previewUrl;
			if (this.isOfficeFile(fileType)) {
				// Usar Microsoft Office Online Viewer para archivos de Office
				previewUrl = this.getOfficePreviewUrl(fileUrl);
			} else {
				// Para otros archivos, abrir directamente
				previewUrl = fileUrl;
			}
			
			// Abrir en nueva pestaña
			window.open(previewUrl, '_blank');
			
			this.$set(this.loadingEvidences, evidenceId, false);
		},

		async openPdfInNewTab(pdfUrl, fileName) {
			// Intentar descargar el PDF como blob para evitar Content-Disposition: attachment
			// y mostrarlo embebido en un iframe
			let embedUrl = null;
			let downloadUrl = pdfUrl;
			try {
				const response = await fetch(pdfUrl);
				if (response.ok) {
					const blob = await response.blob();
					// Forzar tipo application/pdf por si el server devuelve otro
					const pdfBlob = new Blob([blob], { type: 'application/pdf' });
					embedUrl = URL.createObjectURL(pdfBlob);
					downloadUrl = embedUrl;
				}
			} catch (e) {
				embedUrl = null;
			}

			// Si el fetch falló (probablemente CORS), usar Google Docs Viewer como fallback
			// para evitar que el navegador descargue el archivo por Content-Disposition: attachment
			if (!embedUrl) {
				embedUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;
			}

			const htmlContent = `
				<!DOCTYPE html>
				<html lang="es">
				<head>
					<meta charset="UTF-8">
					<meta name="viewport" content="width=device-width, initial-scale=1.0">
					<title>${fileName}</title>
					<style>
						* { margin: 0; padding: 0; box-sizing: border-box; }
						html, body {
							height: 100vh;
							background-color: #1a1a1a;
							display: flex;
							flex-direction: column;
						}
						.header {
							background-color: #2d2d2d;
							padding: 12px 20px;
							display: flex;
							justify-content: space-between;
							align-items: center;
							color: white;
							font-family: Arial, sans-serif;
						}
						.header h1 {
							font-size: 16px;
							font-weight: normal;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							max-width: 70%;
						}
						.download-btn {
							background-color: #0039a6;
							color: white;
							border: none;
							padding: 8px 16px;
							border-radius: 4px;
							cursor: pointer;
							font-size: 14px;
							text-decoration: none;
						}
						.download-btn:hover { background-color: #002d7a; }
						.pdf-container {
							flex: 1;
							display: flex;
						}
						.pdf-container iframe {
							flex: 1;
							width: 100%;
							height: 100%;
							border: none;
						}
					</style>
				</head>
				<body>
					<div class="header">
						<h1>${fileName}</h1>
						<a href="${downloadUrl}" download="${fileName}" class="download-btn">Descargar</a>
					</div>
					<div class="pdf-container">
						<iframe src="${embedUrl}" type="application/pdf"></iframe>
					</div>
				</body>
				</html>
			`;

			const blob = new Blob([htmlContent], { type: 'text/html' });
			const blobUrl = URL.createObjectURL(blob);
			window.open(blobUrl, '_blank');
		},

		openImageInNewTab(imageUrl, fileName) {
			const htmlContent = `
				<!DOCTYPE html>
				<html lang="es">
				<head>
					<meta charset="UTF-8">
					<meta name="viewport" content="width=device-width, initial-scale=1.0">
					<title>${fileName}</title>
					<style>
						* { margin: 0; padding: 0; box-sizing: border-box; }
						body {
							background-color: #1a1a1a;
							min-height: 100vh;
							display: flex;
							flex-direction: column;
						}
						.header {
							background-color: #2d2d2d;
							padding: 12px 20px;
							display: flex;
							justify-content: space-between;
							align-items: center;
							color: white;
							font-family: Arial, sans-serif;
						}
						.header h1 {
							font-size: 16px;
							font-weight: normal;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							max-width: 70%;
						}
						.download-btn {
							background-color: #0039a6;
							color: white;
							border: none;
							padding: 8px 16px;
							border-radius: 4px;
							cursor: pointer;
							font-size: 14px;
							text-decoration: none;
						}
						.download-btn:hover {
							background-color: #002d7a;
						}
						.image-container {
							flex: 1;
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 20px;
							overflow: auto;
						}
						.image-container img {
							max-width: 100%;
							max-height: calc(100vh - 80px);
							object-fit: contain;
						}
					</style>
				</head>
				<body>
					<div class="header">
						<h1>${fileName}</h1>
						<a href="${imageUrl}" download="${fileName}" class="download-btn">Descargar</a>
					</div>
					<div class="image-container">
						<img src="${imageUrl}" alt="${fileName}" />
					</div>
				</body>
				</html>
			`;
			
			const blob = new Blob([htmlContent], { type: 'text/html' });
			const blobUrl = URL.createObjectURL(blob);
			window.open(blobUrl, '_blank');
		},

		isImageFile(extension) {
			const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
			return imageExtensions.includes(extension?.toLowerCase());
		},

		isPdfFile(extension) {
			return extension?.toLowerCase() === 'pdf';
		},

		isOfficeFile(extension) {
			const officeExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
			return officeExtensions.includes(extension?.toLowerCase());
		},

		getOfficePreviewUrl(fileUrl) {
			// Usar Microsoft Office Online Viewer para archivos de Office
			const encodedUrl = encodeURIComponent(fileUrl);
			return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
		},

		getRating,
		changeFilter() { },
		startTicket() {
			this.$swal({
				icon: 'question',
				title: 'Confirmación de Inicio',
				text: '¿Estás seguro de que deseas iniciar con este ticket?',
				showCancelButton: true,
				confirmButtonText: 'Sí, iniciar',
				cancelButtonText: 'Cancelar',
				confirmButtonColor: '#0039a6',
				cancelButtonColor: 'grey',
			}).then(async (result) => {
				if (result.isConfirmed) {
					// Iniciar Ticket / Crear Ticket-Attention
					await this.initiateTicket();
					// this.mode = 'TICKETSTARTED';
				}
			});
		},

		async getRequestId() {
			try {
				this.loading = true;
				const id = this.$route.params.requestId;
				const { error } = await this.getTicketById(id);
				if (error) showError(error);
				this.loading = false;
			} catch (ex) {
				console.log(ex);
			}
		},

		async initiateTicket(attentionType) {
			this.loadingInitTicket = true;
			const payload = {
				ticket: this.$route.params.requestId,
				attention_type: attentionType,
			};

			const { ok, error } = await this.createTicketAttention(payload);
			if (ok) {
				this.loadingInitTicket = false;
				this.getRequestId();
			} else {
				showError(error);
				this.loadingInitTicket = false;
			}
		},

		formatDate(dateString) {
			if (!dateString) {
				return '-';
			}
			return moment(dateString).format('DD/MM/YYYY HH:mm');
		},

		printArea(item) {
			return (
				item?.subtype?.classification?.area?.name +
				' / ' +
				item?.subtype?.classification?.name +
				' / ' +
				item?.subtype?.name
			);
		},

		printSubtypes(subtype) {
			const tree = this.$store.getters['ticket/getSubtypeParents'](subtype.id);
			const treeNames = tree.map(s => s.name);
			return treeNames.join(' / ');
		},

		printAssets(assets) {
			let assetsText = [];
			if (Array.isArray(assets)) {
				assets.forEach((asset) => {
					assetsText.push(asset?.name + ' ' + asset?.serial_number);
				});
			}
			return assetsText.join(', ');
		},

		openDialog() {
			this.showDialog = true;
		},

		setTicketStatus(value) {
			this.ticket.status = value;
		},

		getNamefile(url) {
			try {
				const urlParts = url.split('/');
				const fileNameWithTimestamp = urlParts[urlParts.length - 1];
				const fileNameParts = fileNameWithTimestamp.split('-');
				fileNameParts.shift();
				const fileName = fileNameParts.join('-');
				const filenameFinal = fileName.split('?')[0];
				return filenameFinal;
			} catch (error) {
				return 'EVIDENCIA';
			}
		},

		reassignUser() {
			//this.item = Object.assign({}, request);
			this.reassignUserDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		addUserConfirm() {
			this.userConfirmDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		addUser() {
			this.addUserDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		additionalUsers() {
			this.additionalUsersDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		reassignedUserHistory() {
			this.reassignedUserHistoryDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		hasPermission(structure, userId) {
			while (structure) {
				if (structure.responsible_id && structure.responsible_id.id === userId) {
					return true;
				}
				structure = structure.parent;
			}
			return false;
		},

		validateUserPermission(ticket, userId) {
			if (ticket?.subtype && this.hasPermission(ticket?.subtype, userId)) {
				return true;
			}

			if (ticket?.subtype && ticket?.subtype?.classification) {
				const classification = ticket?.subtype?.classification;
				for (const subtype of classification?.subtypes) {
					if (this.hasPermission(subtype, userId)) {
						return true;
					}
				}
			}
			return false;
		},

		disableButtonReassignResponsible(item) {
			const statusIsValid =
				item.status === 'SOLICITADO' ||
				item.status === 'CONSULTA' ||
				item.status === 'RESUELTO';

			const userIsAuthorized =
				item.subtype.classification.responsible_id.id === this.user.id ||
				item.subtype.classification.area.responsible_id.id === this.user.id ||
				this.hasDisabledTicketReassign;

			const shouldEnableButton = statusIsValid && userIsAuthorized;

			return !shouldEnableButton;
		},

		openReclassifyDialog() {
			this.reclassifyDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		openChangeCompanyDialog() {
			this.changeCompanyDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},

		getFileName(url) {
			if (!url) return 'Archivo';
			try {
				const urlObj = new URL(url);
				const pathname = urlObj.pathname;
				let filename = pathname.split('/').pop();
				// Decodificar caracteres URL y remover timestamp prefix si existe
				filename = decodeURIComponent(filename);
				// Remover el prefijo de timestamp (ej: 1761584772672-)
				filename = filename.replace(/^\d+-/, '');
				return filename || 'Archivo';
			} catch {
				return 'Archivo';
			}
		},

		getFileExtension(url) {
			if (!url) return '';
			const filename = this.getFileName(url);
			const parts = filename.split('.');
			return parts.length > 1 ? parts.pop().toLowerCase() : '';
		},

		getFileIcon(url) {
			const extension = this.getFileExtension(url);
			const iconMap = {
				// Imágenes
				jpg: 'mdi-file-image',
				jpeg: 'mdi-file-image',
				png: 'mdi-file-image',
				gif: 'mdi-file-image',
				bmp: 'mdi-file-image',
				webp: 'mdi-file-image',
				svg: 'mdi-file-image',
				// Documentos
				pdf: 'mdi-file-pdf-box',
				doc: 'mdi-file-word',
				docx: 'mdi-file-word',
				// Hojas de cálculo
				xls: 'mdi-file-excel',
				xlsx: 'mdi-file-excel',
				csv: 'mdi-file-excel',
				// Presentaciones
				ppt: 'mdi-file-powerpoint',
				pptx: 'mdi-file-powerpoint',
				// Texto
				txt: 'mdi-file-document-outline',
				// Comprimidos
				zip: 'mdi-folder-zip',
				rar: 'mdi-folder-zip',
				'7z': 'mdi-folder-zip',
				// Videos
				mp4: 'mdi-file-video',
				avi: 'mdi-file-video',
				mov: 'mdi-file-video',
				wmv: 'mdi-file-video',
				// Audio
				mp3: 'mdi-file-music',
				wav: 'mdi-file-music',
			};
			return iconMap[extension] || 'mdi-file-outline';
		},

		getFileIconColor(url) {
			const extension = this.getFileExtension(url);
			const colorMap = {
				// Imágenes - púrpura
				jpg: '#9C27B0',
				jpeg: '#9C27B0',
				png: '#9C27B0',
				gif: '#9C27B0',
				bmp: '#9C27B0',
				webp: '#9C27B0',
				svg: '#9C27B0',
				// PDF - rojo
				pdf: '#F44336',
				// Word - azul
				doc: '#2196F3',
				docx: '#2196F3',
				// Excel - verde
				xls: '#4CAF50',
				xlsx: '#4CAF50',
				csv: '#4CAF50',
				// PowerPoint - naranja
				ppt: '#FF9800',
				pptx: '#FF9800',
				// Comprimidos - marrón
				zip: '#795548',
				rar: '#795548',
				'7z': '#795548',
				// Videos - rosa
				mp4: '#E91E63',
				avi: '#E91E63',
				mov: '#E91E63',
				wmv: '#E91E63',
				// Audio - cian
				mp3: '#00BCD4',
				wav: '#00BCD4',
			};
			return colorMap[extension] || 'primary';
		},

	},
	beforeDestroy() {
		this.cleanTicket();
	},
	components: {
		UserConfirmDialog,
		TicketItem,
		TicketComments: TicketCommentsRich,
		RatingDialog,
		ReassignUserDialog,
		TicketDetailElement,
		AddUserTicketDialog,
		UserAdditionalDialog,
		ReassignedUserHistoryDialog,
		TicketAttentionDialog,
		TicketReclassifyDialog,
		TicketChangeCompanyDialog,
		HtmlViewer,
	},
};
